const JobTypes = {
  MD_CONFIGURATION_DEPLOYMENT: "mdConfigurationDeployment",
  CRM_CONFIGURATION_DEPLOYMENT: "crmConfigurationDeployment",
  AI_EMAIL_TEMPLATES_DEPLOYMENT: "aiEmailTemplatesDeployment"
};

JobTypes.ALL = Object.values(JobTypes);

export default JobTypes;
